import { endpoints } from 'core/api/endpoints';
import { apiGet, apiPatch, apiPost } from 'core/api/client';
import { queryFilters } from 'features/company-plans/companyPlans.helpers';

function get(path, filters, config) {
  return apiGet(path, { ...config, params: queryFilters(filters) });
}

export const companyPlansApi = {
  listPlans(filters, config) {
    return get(endpoints.companyPlans, filters, config);
  },
  showPlan(id, config) {
    return apiGet(endpoints.companyPlan(id), config);
  },
  createPlan(body, config) {
    return apiPost(endpoints.companyPlans, body, config);
  },
  updatePlan(id, body, config) {
    return apiPatch(endpoints.companyPlan(id), body, config);
  },
  setPlanActivation(id, isActive, config) {
    return apiPatch(endpoints.companyPlanActivation(id), { is_active: isActive }, config);
  },

  listCompanies(filters, config) {
    return get(endpoints.companies, filters, config);
  },
  showCompany(id, config) {
    return apiGet(endpoints.company(id), config);
  },
  setCompanyStatus(id, status, config) {
    return apiPatch(endpoints.companyStatus(id), { status }, config);
  },

  listPurchases(filters, config) {
    return get(endpoints.planPurchases, filters, config);
  },
  showPurchase(id, config) {
    return apiGet(endpoints.planPurchase(id), config);
  },
  confirmPurchasePayment(id, body, config) {
    return apiPost(endpoints.planPurchaseConfirmPayment(id), body, config);
  },

  listEntitlements(filters, config) {
    return get(endpoints.companyEntitlements, filters, config);
  },
  showEntitlement(id, config) {
    return apiGet(endpoints.companyEntitlement(id), config);
  },
  suspendEntitlement(id, config) {
    return apiPost(endpoints.companyEntitlementSuspend(id), {}, config);
  },
  restoreEntitlement(id, config) {
    return apiPost(endpoints.companyEntitlementRestore(id), {}, config);
  },
  revokeEntitlement(id, config) {
    return apiPost(endpoints.companyEntitlementRevoke(id), {}, config);
  },

  listCodeBatches(filters, config) {
    return get(endpoints.accessCodeBatches, filters, config);
  },
  showCodeBatch(id, config) {
    return apiGet(endpoints.accessCodeBatch(id), config);
  },
  listAccessCodes(filters, config) {
    return get(endpoints.accessCodes, filters, config);
  },
  showAccessCode(id, config) {
    return apiGet(endpoints.accessCode(id), config);
  },
  revokeAccessCode(id, config) {
    return apiPost(endpoints.accessCodeRevoke(id), {}, config);
  },

  listSponsoredAssessments(filters, config) {
    return get(endpoints.sponsoredAssessments, filters, config);
  },
  showSponsoredAssessment(attemptId, config) {
    return apiGet(endpoints.sponsoredAssessment(attemptId), config);
  },
};
